// extracted by mini-css-extract-plugin
export default {"dash":"EmptyDash-module--dash--afzyX"};